<script>
    import UploadImage from '@/components/base-components/UploadImage.vue';
    import { updateFilterImage } from '@/api/filters.js';

    export default {
        components: {
            UploadImage: UploadImage,
        },
        computed: {
            editData() {return this.$store.getters.FILTER_DATA_EDIT},
            filter() {return this.$store.getters.FILTER_BY_ID(this.editData.asset_type_id, this.editData.id)}
        },
        methods: {
            async updateImage(event) {
                const file = event.target.files[0];
                const response = await updateFilterImage(file, this.editData.id);
                if (response != null) {
                    this.filter.icon_path = response.url;
                }
            }
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <UploadImage 
            :uploadMethod="updateImage"
        />
        <div class="upload_image_container mt_10">
            <img :src="filter['icon_path']">
        </div>
    </div>
</template>